module.exports = __webpack_public_path__ + "static/media/cam_events.5cf4c993.png";